import { useState } from "react";
import { useList } from "@refinedev/core";
import { Search } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { PageHeader } from "@/components/forms/PageHeader";
import { MoneyDisplay } from "@/components/forms/MoneyDisplay";
import { formatDate } from "@/lib/formatters";

interface Cliente {
  id: string;
  documento: string;
  nombre_completo: string;
  telefono: string | null;
  ciudad: string | null;
  cantidad_compras: number;
  total_comprado: number;
  ultima_compra: string | null;
}

export function ClientesPage() {
  const [q, setQ] = useState("");
  const navigate = useNavigate();
  const { data, isLoading } = useList<Cliente>({
    resource: "clientes",
    filters: q
      ? [
          {
            operator: "or",
            value: [
              { field: "nombre_completo", operator: "contains", value: q },
              { field: "documento", operator: "contains", value: q },
            ],
          },
        ]
      : [],
    pagination: { pageSize: 50 },
  });

  return (
    <div>
      <PageHeader title="Clientes" subtitle="Búsqueda por nombre o documento" />
      <div className="card p-3 mb-4 flex items-center gap-2">
        <Search className="size-4 text-fg-muted" />
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Buscar..."
          className="flex-1 bg-transparent outline-none"
        />
      </div>

      {isLoading ? (
        <div className="card p-8 text-center text-fg-muted">Cargando...</div>
      ) : data?.data.length === 0 ? (
        <div className="card p-8 text-center text-fg-muted">Sin resultados</div>
      ) : (
        <ul className="space-y-2">
          {data?.data.map((c) => (
            <li key={c.id}>
              <button
                onClick={() => navigate(`/ventas?cliente_documento=${c.documento}`)}
                className="card p-4 flex items-center gap-3 hover:bg-bg w-full text-left"
                title="Ver ventas de este cliente"
              >
                <div className="flex-1">
                  <p className="font-medium">{c.nombre_completo}</p>
                  <p className="text-sm text-fg-muted">
                    {c.documento}
                    {c.ciudad && ` · ${c.ciudad}`}
                  </p>
                </div>
                <div className="text-right">
                  <p className="text-sm">{c.cantidad_compras} compra(s)</p>
                  <MoneyDisplay value={c.total_comprado} className="text-xs text-fg-muted" />
                  {c.ultima_compra && (
                    <p className="text-xs text-fg-muted">Última: {formatDate(c.ultima_compra)}</p>
                  )}
                </div>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
